module.exports = __webpack_public_path__ + "img/wqcl4.fbd075ff.png";